export default __webpack_public_path__ + "static/media/9-buttonRadio.83983dd1.png";